import React, { createContext, useContext } from "react";

const AdContext = createContext({ shouldShowAds: false });

export const AdProvider = ({ shouldShowAds, children }) => (
  <AdContext.Provider value={{ shouldShowAds }}>{children}</AdContext.Provider>
);

export const useAds = () => useContext(AdContext);

export default AdContext;
